var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('slider'),_c('popular-categories'),_c('special-offer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }